<template>
  <div class="remark-component">
    <app-form-field
      id="remark"
      :title="i18n.t('/ExchangeCar/Remarks')"
      class="remark"
      :show-label="false"
    >
      <form-text-area
        id="remark"
        v-model="changeOrder.CarConfiguration.Remark"
        name="remark"
        title="Deze opmerkingen zijn alleen zichtbaar in de CST"
        :disabled="!canChangeRemark"
        @change="onChangeRemark"
      />
    </app-form-field>
  </div>
</template>
<script>
import FormTextArea from '@/components/generic/presentational/atoms/formTextarea/FormTextarea.vue'
import AppFormField from '@/components/generic/presentational/atoms/formField/FormField.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    AppFormField,
    FormTextArea,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      remark: '',
      disable: false,
      showAddButton: true,
      showInput: false,
    }
  },
  computed: {
    ...mapGetters({ changeOrder: 'changeOrder/get' }),
    canChangeRemark() {
      return this.changeOrder?.AudiExclusiveNotice !== 'BLOCKED'
    },
  },
  methods: {
    onChangeRemark() {
      this.$store.commit('changeOrder/setRemarkChanged')
    },
  },
}
</script>
<style lang="scss" scoped>
.remark-component {
  margin-bottom: 30px;
}

.remark {
  grid-column: span 4;
  grid-row: 4;
}

#remark-container {
  margin: 10px;
}
</style>
